function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Stability ball");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1068.22,266.87a105.8,105.8,0,0,0,8.38-12.34l-59.12-9.7,63.94.47a107.93,107.93,0,0,0,2.06-85.4L997.7,204.4l79.11-58.15a107.78,107.78,0,1,0-178,120.62,108.18,108.18,0,0,0-12.29,19.65l76.74,39.87-81.82-27.46A107.83,107.83,0,0,0,898.8,400.14a107.79,107.79,0,0,0,64.83,172.57,37,37,0,0,0-2.13,12.52,35.52,35.52,0,0,0,4.69,18,36.89,36.89,0,0,0,0,36,36.89,36.89,0,0,0,0,36,36.89,36.89,0,0,0,0,36,35.52,35.52,0,0,0-4.69,18c0,16.27,10.07,29.45,22.5,29.45s22.5-13.18,22.5-29.45a35.53,35.53,0,0,0-4.7-18,36.82,36.82,0,0,0,0-36,36.82,36.82,0,0,0,0-36,36.82,36.82,0,0,0,0-36,35.53,35.53,0,0,0,4.7-18,37.1,37.1,0,0,0-2.19-12.69,107.79,107.79,0,0,0,63.91-172.4,107.77,107.77,0,0,0,0-133.27Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M711.83,381.57a72.48,72.48,0,0,1-5.6-8.25l39.53-6.49-42.75.31a72.17,72.17,0,0,1-1.38-57.1L759,339.8l-52.9-38.89a72.07,72.07,0,1,1,119,80.66,71.75,71.75,0,0,1,8.22,13.14L782,421.37,836.74,403a72.06,72.06,0,0,1-11.62,67.68,72.07,72.07,0,0,1-43.34,115.4,24.83,24.83,0,0,1,1.42,8.37,23.7,23.7,0,0,1-3.14,12,24.63,24.63,0,0,1,0,24.07,24.65,24.65,0,0,1,0,24.08,24.63,24.63,0,0,1,0,24.07,23.71,23.71,0,0,1,3.14,12c0,10.87-6.73,19.69-15,19.69s-15-8.82-15-19.69a23.71,23.71,0,0,1,3.14-12,24.63,24.63,0,0,1,0-24.07,24.65,24.65,0,0,1,0-24.08,24.63,24.63,0,0,1,0-24.07,23.7,23.7,0,0,1-3.14-12,24.76,24.76,0,0,1,1.47-8.49,72.08,72.08,0,0,1-42.75-115.28,72.08,72.08,0,0,1,0-89.11Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
});

var _ref5 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 562.16,
  cy: 652.08,
  rx: 500.85,
  ry: 63,
  fill: "#f2f2f2"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M784.47,602.84c0,2-.06,4-.17,5.92,0,.29,0,.57,0,.86a107.09,107.09,0,0,1-4.57,24.89c-.07.25-.16.52-.24.77a115.19,115.19,0,0,1-10.26,23.09l-.43.72a128.5,128.5,0,0,1-16,21.46l-.62.66a146,146,0,0,1-22.53,19.68c-.28.21-.57.42-.85.61a166.55,166.55,0,0,1-27.17,15.44c-1.31.59-2.63,1.17-4,1.74l-1.2.5A188.12,188.12,0,0,1,651,731.51l-1.91.26a201.11,201.11,0,0,1-26.42,1.73c-65.48,0-121.88-31.42-147.33-76.63q-2.57-4.53-4.69-9.24l-.58-1.29A108.54,108.54,0,0,1,461,607.45c0-.33,0-.65,0-1,0-1.2-.05-2.41-.05-3.62a106.78,106.78,0,0,1,3.64-27.69c.07-.28.14-.55.22-.82a113.32,113.32,0,0,1,11-26.32c.13-.23.26-.47.4-.7A127.48,127.48,0,0,1,492.77,525a7.23,7.23,0,0,1,.53-.59l.08-.08c.79-.84,1.59-1.69,2.41-2.52l1.23-1.24c.81-.81,1.64-1.6,2.47-2.4l.05,0q3-2.82,6.11-5.47c2.88-2.44,5.89-4.79,9-7.05l.67-.5a167,167,0,0,1,26.22-15.31c.27-.13.55-.27.82-.38a182,182,0,0,1,32.19-11.34c.35-.1.69-.18,1-.26a196.7,196.7,0,0,1,41.82-5.55c.47,0,.94,0,1.42,0,1.28,0,2.57-.05,3.86-.05,64.89,0,120.86,30.87,146.64,75.4.23.4.45.8.68,1.19l1,1.75c.55,1,1.07,2,1.59,3.06.24.48.47.95.7,1.43.14.28.29.56.42.85h0a110.21,110.21,0,0,1,8.43,24.62c.08.33.14.65.21,1A107,107,0,0,1,784.47,602.84Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#4527a0"
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M770,548.76q-11.09-4.2-22-8.74a852.93,852.93,0,0,1-130.55-67.77l1.42,0a853.15,853.15,0,0,0,150.5,75.36C769.56,548,769.78,548.37,770,548.76Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M782.31,581.44q-27-9-53.43-20A853,853,0,0,1,597.05,492.9q-11.84-7.53-22.5-14.85l1-.25q10.41,7.11,22,14.48a852.72,852.72,0,0,0,184.55,88.2C782.18,580.8,782.24,581.12,782.31,581.44Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
}));

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M784.3,608.76c0,.29,0,.58,0,.86q-37.69-11.49-74.45-26.68A853.06,853.06,0,0,1,578,514.35c-13.25-8.43-25.41-16.69-36.43-24.57l.82-.39c10.93,7.81,23,16,36.1,24.34A850.25,850.25,0,0,0,784.3,608.76Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
}));

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M779.68,634.5c-.07.27-.16.53-.24.79a822.66,822.66,0,0,1-88.72-30.9,852.13,852.13,0,0,1-131.83-68.58c-16.46-10.47-31.23-20.69-44.24-30.22l.67-.49c13,9.49,27.68,19.66,44.06,30.09A848.43,848.43,0,0,0,779.68,634.5Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
}));

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M769.18,658.37l-.43.72a820.28,820.28,0,0,1-97.11-33.24A853.56,853.56,0,0,1,539.8,557.27c-17.64-11.23-33.36-22.18-47-32.29.16-.19.34-.39.53-.58,13.66,10.1,29.37,21,47,32.25C592.7,590,671.14,631.49,769.18,658.37Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
}));

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M752.76,680.55l-.62.66a818.63,818.63,0,0,1-99.58-33.9,853.1,853.1,0,0,1-131.84-68.58C504,568.07,489,557.68,475.81,548c.13-.23.26-.46.4-.69,13.19,9.69,28.23,20.11,45,30.79C574.09,611.77,653.48,653.7,752.76,680.55Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
}));

var _ref13 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M729.61,700.89c-.28.21-.57.42-.85.61a821.81,821.81,0,0,1-95.28-32.73,852.65,852.65,0,0,1-131.84-68.58c-13.5-8.6-25.89-17-37.08-25.05.07-.27.14-.54.22-.81,11.27,8.07,23.74,16.57,37.36,25.24C554.29,632.77,632.23,674,729.61,700.89Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
}));

var _ref14 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M697.62,718.68l-1.2.5a821.19,821.19,0,0,1-82-28.95c-26-10.75-51.61-22.88-76.59-36.25q-28.2-15.12-55.25-32.33-11.31-7.2-21.54-14.2c0-.33,0-.65,0-1q10.48,7.15,22.09,14.56c16.43,10.47,35.43,21.73,56.79,33.1A844.07,844.07,0,0,0,697.62,718.68Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
}));

var _ref15 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M651,731.51l-1.91.26q-27.17-9.09-53.8-20.09A849.69,849.69,0,0,1,484,655.73q-6.68-4-13.3-8.1l-.58-1.29q7.29,4.54,15.18,9.25A851.6,851.6,0,0,0,651,731.51Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
}));

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M701.59,716.94c-1.31.59-2.63,1.17-4,1.74l-1.2.5A188.12,188.12,0,0,1,651,731.51l-1.91.26a201.11,201.11,0,0,1-26.42,1.73c-65.48,0-121.88-31.42-147.33-76.63,2.86-.44,5.73-.81,8.61-1.14l1.3-.14c7.74-.82,15.54-1.28,23.32-1.61a279.21,279.21,0,0,1,29.22,0c.68,0,1.36.08,2,.14A134,134,0,0,1,559.5,657c19.75,4.48,37.85,14.21,55.79,23.6C643,695.06,671.33,709.16,701.59,716.94Z",
  transform: "translate(-68.5 -92.46)",
  opacity: 0.1
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M769.33,547.57c-25.78-44.53-81.75-75.4-146.64-75.4-1.29,0-2.58,0-3.86,0l-1.42,0a196.06,196.06,0,0,0-41.82,5.55l-1,.25a183.63,183.63,0,0,0-32.19,11.34l-.82.39a166.27,166.27,0,0,0-26.22,15.32l-.67.49a145.36,145.36,0,0,0-21.27,18.74c-.84,8.53-2.28,16.88-6,24.57-2.62,5.4-5.33,10.6-1.62,16,2.49,3.63,7.88,8.23,12.47,8.41,12.61.51,19.62-16.35,25.56-24.75,9.1-12.86,22.59-21.79,35.77-30.42,5.63-3.69,11.32-7.41,17.67-9.62a60.67,60.67,0,0,1,16.55-2.91c15.33-.86,31,1.47,45,7.82,16,7.25,30.2,19.75,47.66,21.48,7.91.78,16-.75,23.75,1.06,13.77,3.23,23.32,16.22,36.72,20.76,8.67,2.94,18,2,26.82-.88q-1.71-3.6-3.67-7.09C769.78,548.37,769.56,548,769.33,547.57Z",
  transform: "translate(-68.5 -92.46)",
  opacity: 0.1
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M377.14,597.68c-4.74,5-10.06,9.39-14.95,14.24-18.11,18-29.72,41.39-46,61-4.39,5.29-9.16,10.37-12.43,16.41s-4.91,13.39-2.57,19.85c2,5.54,6.61,9.69,11.09,13.52a50.93,50.93,0,0,0,9.05,6.63c7.52,4,16.42,4.22,24.94,4.35,4.7.07,10.43-.46,12.44-4.71a82.57,82.57,0,0,1-20.8-14.16c-3.53-3.3-6.86-7.08-8.29-11.69-2.44-7.86,1.17-16.42,6.28-22.87s11.7-11.62,16.69-18.16,8.21-14.05,14.22-19.39c4.16-3.69,9.33-6,14-9.07,6.82-4.49,12.45-10.53,18-16.51l29.5-31.73a4.21,4.21,0,0,0,1.39-2.35c.12-1.19-.76-2.23-1.6-3.09-6.42-6.59-18.52-18.16-27.34-9.48C392.26,578.83,385.37,589,377.14,597.68Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#a0616a"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M377.14,597.68c-4.74,5-10.06,9.39-14.95,14.24-18.11,18-29.72,41.39-46,61-4.39,5.29-9.16,10.37-12.43,16.41s-4.91,13.39-2.57,19.85c2,5.54,6.61,9.69,11.09,13.52a50.93,50.93,0,0,0,9.05,6.63c7.52,4,16.42,4.22,24.94,4.35,4.7.07,10.43-.46,12.44-4.71a82.57,82.57,0,0,1-20.8-14.16c-3.53-3.3-6.86-7.08-8.29-11.69-2.44-7.86,1.17-16.42,6.28-22.87s11.7-11.62,16.69-18.16,8.21-14.05,14.22-19.39c4.16-3.69,9.33-6,14-9.07,6.82-4.49,12.45-10.53,18-16.51l29.5-31.73a4.21,4.21,0,0,0,1.39-2.35c.12-1.19-.76-2.23-1.6-3.09-6.42-6.59-18.52-18.16-27.34-9.48C392.26,578.83,385.37,589,377.14,597.68Z",
  transform: "translate(-68.5 -92.46)",
  opacity: 0.1
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M419.3,540c5.95-1.26,12.36,1.91,18.11-.06,3.26-1.12,5.75-3.72,8.1-6.24l9.6-10.23c2.71-2.89,5.47-5.84,7.14-9.44,1.48-3.18,2-6.69,2.72-10.13,1.76-8.8,4.77-17.82,11.38-23.88,8.24-7.58,20.94-9,31.52-5.38s19.19,11.7,25.52,20.94c-5.66,6.8-12,13.08-17.65,19.88a32.79,32.79,0,0,1-6.31,6.31A35.24,35.24,0,0,1,501,525.5c-10.17,3.6-21,8.81-25.19,18.76-1.46,3.46-2,7.23-2.8,10.9-1.54,6.94-4.35,13.81-9.43,18.78s-12.75,7.69-19.52,5.54c-7.49-2.38-12.08-9.72-15.94-16.56A79.88,79.88,0,0,1,419.3,540Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#a0616a"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M419.3,540c5.95-1.26,12.36,1.91,18.11-.06,3.26-1.12,5.75-3.72,8.1-6.24l9.6-10.23c2.71-2.89,5.47-5.84,7.14-9.44,1.48-3.18,2-6.69,2.72-10.13,1.76-8.8,4.77-17.82,11.38-23.88,8.24-7.58,20.94-9,31.52-5.38s19.19,11.7,25.52,20.94c-5.66,6.8-12,13.08-17.65,19.88a32.79,32.79,0,0,1-6.31,6.31A35.24,35.24,0,0,1,501,525.5c-10.17,3.6-21,8.81-25.19,18.76-1.46,3.46-2,7.23-2.8,10.9-1.54,6.94-4.35,13.81-9.43,18.78s-12.75,7.69-19.52,5.54c-7.49-2.38-12.08-9.72-15.94-16.56A79.88,79.88,0,0,1,419.3,540Z",
  transform: "translate(-68.5 -92.46)",
  opacity: 0.1
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M679.81,500.28c37.58,13.45,74.94,29.38,106,54.5,14.22,11.51,26.89,24.79,40.41,37.12,7.08,6.46,14.39,12.65,21.7,18.85l51.89,44c6.42,5.45,12.87,10.91,20,15.47C936.58,681,956.58,686.48,973,698.07a53.2,53.2,0,0,0,2.9,17.59,10.12,10.12,0,0,0,10.26,6.69c25.86-1.49,52.08,11.06,78.13,7.9a4.9,4.9,0,0,0,3.67-2.35c1.75-3.06-1.24-5.92-3.86-7.75l-35.37-24.76c-5.83-4.08-11.66-8.16-17.6-12.07C989.65,669.2,966.71,657.21,946.8,641c-4.25-3.46-8.34-7.1-12.44-10.75-21.68-19.26-43.37-38.54-63.92-59-29.87-29.75-58.12-62.94-87.73-92.95a82.08,82.08,0,0,0-9.08-8.31,83.7,83.7,0,0,0-9.91-6.07l-37.59-20.65c-5.69-3.13-12-6.36-18.35-5.13a9.84,9.84,0,0,0-9,2.3c-2.42,2.23-4,5.18-5.6,8.07a49.17,49.17,0,0,0-4.9,11.15c-1.34,5.31-.9,11-2.45,16.22-1,3.45-2.86,6.6-4.12,10A34.36,34.36,0,0,0,679.81,500.28Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#a0616a"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M679.81,500.28c37.58,13.45,74.94,29.38,106,54.5,14.22,11.51,26.89,24.79,40.41,37.12,7.08,6.46,14.39,12.65,21.7,18.85l51.89,44c6.42,5.45,12.87,10.91,20,15.47C936.58,681,956.58,686.48,973,698.07a53.2,53.2,0,0,0,2.9,17.59,10.12,10.12,0,0,0,10.26,6.69c25.86-1.49,52.08,11.06,78.13,7.9a4.9,4.9,0,0,0,3.67-2.35c1.75-3.06-1.24-5.92-3.86-7.75l-35.37-24.76c-5.83-4.08-11.66-8.16-17.6-12.07C989.65,669.2,966.71,657.21,946.8,641c-4.25-3.46-8.34-7.1-12.44-10.75-21.68-19.26-43.37-38.54-63.92-59-29.87-29.75-58.12-62.94-87.73-92.95a82.08,82.08,0,0,0-9.08-8.31,83.7,83.7,0,0,0-9.91-6.07l-37.59-20.65c-5.69-3.13-12-6.36-18.35-5.13a9.84,9.84,0,0,0-9,2.3c-2.42,2.23-4,5.18-5.6,8.07a49.17,49.17,0,0,0-4.9,11.15c-1.34,5.31-.9,11-2.45,16.22-1,3.45-2.86,6.6-4.12,10A34.36,34.36,0,0,0,679.81,500.28Z",
  transform: "translate(-68.5 -92.46)",
  opacity: 0.1
});

var _ref24 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 356.33,
  cy: 483,
  r: 42.31,
  fill: "#a0616a"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M682.31,422.68c5.91.1,12.62.56,16.34,5.15s2.88,10.88,1.94,16.54c-2.94,17.89-6,36.1-14.18,52.28a7.46,7.46,0,0,1-2.91,3.55c-2.35,1.21-5.14-.21-7.39-1.6-16.39-10.18-32.78-21.14-51.46-26a4.66,4.66,0,0,1-2.91-1.55,4.49,4.49,0,0,1-.17-3.46c1.86-8.29,4.21-16.48,5.67-24.86.88-5-.75-17,3.68-20.1,4.69-3.3,18.2-.51,23.75-.42Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#a0616a"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M702.21,505.26c37.58,13.45,74.94,29.38,105.95,54.49,14.22,11.52,26.89,24.8,40.41,37.13,7.08,6.46,14.39,12.65,21.7,18.84l51.89,44c6.42,5.44,12.87,10.91,20,15.46C959,686,979,691.46,995.36,703a53.21,53.21,0,0,0,2.9,17.6,10.13,10.13,0,0,0,10.26,6.69c25.86-1.5,52.08,11.06,78.13,7.9a4.91,4.91,0,0,0,3.67-2.36c1.75-3-1.24-5.92-3.86-7.75l-35.37-24.75c-5.83-4.08-11.66-8.16-17.6-12.07-21.44-14.12-44.38-26.11-64.29-42.31-4.25-3.46-8.34-7.11-12.44-10.75-21.68-19.26-43.37-38.54-63.93-59-29.86-29.75-58.11-62.94-87.72-93A83.16,83.16,0,0,0,796,475a85,85,0,0,0-9.91-6.06l-37.59-20.65c-5.69-3.13-12-6.36-18.35-5.13a9.81,9.81,0,0,0-9,2.29c-2.42,2.23-4,5.19-5.6,8.08a49.29,49.29,0,0,0-4.9,11.14c-1.34,5.31-.9,11-2.45,16.23-1,3.45-2.86,6.6-4.12,10A34.34,34.34,0,0,0,702.21,505.26Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#a0616a"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M714.68,508.36l1.19-17.31c.34-4.84.68-9.74,2.17-14.35,1.69-5.23,4.77-9.88,7.9-14.4a34.68,34.68,0,0,1,6-7.13c3.41-2.87,7.82-4.43,11-7.54.91-.89,1.76-2.2,1.22-3.35a3.36,3.36,0,0,0-1-1.08c-7.84-6.43-17.24-10.61-26.52-14.72l-17.54-7.76c-7.38,10-14.89,20.31-18.69,32.17a47.53,47.53,0,0,1-2.15,6.18c-2.25,4.69-6.52,8.11-9.23,12.55-2.55,4.18-3.61,9.07-4.62,13.86-.6,2.81-1.18,5.81-.17,8.5,1.12,3,4,4.94,6.62,6.69,11.61,7.61,23.87,15.46,37.72,16.54,2.54.19,5.92,1.46,6.73-1C715.88,514.56,714.55,510.38,714.68,508.36Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#3f3d56"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M368.09,557c-4.38,5.87-1.44,14.42,3.1,20.17s10.61,10.57,13.15,17.44c6.09,16.43-10.9,33-10.32,50.48.52,15.58,14.29,26.87,26,37.22,24.88,22,46.14,52.66,43.34,85.78a49.9,49.9,0,0,0,27.6-20.37,53.71,53.71,0,0,1,4.66,26.63c26.08-17.85,40.93-50.85,37-82.2-1.87-14.84-7.59-29.31-6.7-44.23.48-8.09,2.89-15.92,4.63-23.84A145,145,0,0,0,513.85,593c0-11.92-2.21-25.16-11.61-32.49-8-6.23-19-6.44-29.14-6.39-10.71.07-21.42.12-32.11.79-10.91.68-22.16,4.28-32.9,4.55C396.13,559.76,379.28,542,368.09,557Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#3f3d56"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M528,478.73a44.18,44.18,0,0,0-18.51,11.87c-3.19,3.46-5.83,7.41-9.14,10.76-3.94,4-8.75,7-13.36,10.2-8.81,6.1-17.06,12.95-25.3,19.79l-40.6,33.7c-6.35,5.27-12.7,10.55-18.69,16.23-7.39,7-14.21,14.64-22.1,21.09-4.62,3.78-9.59,7.15-13.83,11.36-4,4-7.24,8.61-10.52,13.18a634.75,634.75,0,0,1-43,53.36c-6.49,7.23-13.2,14.35-21.09,20-16.36,11.79-28.78,29.44-43.16,43.59-1.22,1.2-2.56,2.91-1.81,4.46a3.36,3.36,0,0,0,2,1.51c10.52,3.92,19.58-13.15,30.54-10.73,5,1.1,8.07,5.83,11.65,9.44s9.72,6.27,13.46,2.82a59.44,59.44,0,0,1,3.79-29.64c6.13-15.21,18.29-27.2,31.27-37.24s27.11-18.6,39.3-29.59c20.45-18.43,35.39-43.57,59.65-56.58,9.5-5.1,20-8.08,29.47-13.3,18.33-10.14,31.15-28,41.17-46.37a24.77,24.77,0,0,1,4.72-6.81,26.71,26.71,0,0,1,6.9-3.93,106.13,106.13,0,0,0,34-24.91c-3-2.15-5.81-4.45-8.8-6.61a35.63,35.63,0,0,1-6.63-5.67c-2-2.36-3.3-5.19-5-7.77S530.9,479.66,528,478.73Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#a0616a"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M637.25,481.82c-2.64-2.12-2.73-6-2.6-9.43q.65-15.78,1.28-31.55c.29-7.41,1-15.71,6.59-20.57q-24.25-4.87-48.9-7.47c-6.52-.69-13.13-1.26-19.63-.31-7.83,1.14-15.17,4.42-22.39,7.67-8,3.6-16.05,7.23-23.22,12.28a93.32,93.32,0,0,1-8.62,5.92c-5.44,3-11.69,4-17.55,6a57.17,57.17,0,0,0-37.1,67.77c2-5.17,3.4-10.58,5.74-15.61s5.79-9.78,10.7-12.35c5.12-2.66,11.3-2.64,16.87-1.11S509,487.54,514,490.52c11.14,6.75,22.52,14.63,27.81,26.52,11-8.18,22.25-16,33.27-24.22,4.78-3.55,9.63-7.13,15.17-9.28,7.28-2.83,15.27-3,23.08-3.15S629.61,479.8,637.25,481.82Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#ff6584"
});

var _ref31 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "396.57 418.71 395.24 437.16 400.04 433.2 397.64 416.88 396.57 418.71",
  fill: "#ff6584"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M284.83,274.24l-15.52,9.84L278.73,267a15.34,15.34,0,0,0-9.39-3.35h-.25a18.16,18.16,0,0,1-3.22-.24l-5.26,3.34,2.26-4.1a18.7,18.7,0,0,1-9.2-7l-9.42,6,5.95-10.81c-5.51-6.61-12.93-10.66-21.09-10.66-9.79,0-18.51,5.82-24.14,14.89a18.05,18.05,0,0,1-16,8.61h-.53c-10.81,0-19.57,12.25-19.57,27.37s8.76,27.37,19.57,27.37a14.73,14.73,0,0,0,6.82-1.71,28.22,28.22,0,0,1,23.68-.46,24.66,24.66,0,0,0,20.14,0,28.25,28.25,0,0,1,23.48.46,14.65,14.65,0,0,0,6.74,1.67c10.81,0,19.57-12.26,19.57-27.37A34.71,34.71,0,0,0,284.83,274.24Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M255.58,314.29a28.89,28.89,0,0,0-16.77,1.82,24.71,24.71,0,0,1-20.14-.05,28.22,28.22,0,0,0-23.68.47,14.75,14.75,0,0,1-6.82,1.7c-9.6,0-17.59-9.67-19.25-22.43a18.41,18.41,0,0,0,4.8-5.17c5.62-9.07,14.35-14.9,24.14-14.9s18.4,5.75,24,14.73a18.51,18.51,0,0,0,16,8.76h.25C245.74,299.22,252.36,305.35,255.58,314.29Z",
  transform: "translate(-68.5 -92.46)",
  opacity: 0.03
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M561.8,332.13,554.06,337l4.7-8.54a7.61,7.61,0,0,0-4.68-1.67H554a9.42,9.42,0,0,1-1.6-.12l-2.63,1.66,1.13-2a9.31,9.31,0,0,1-4.59-3.49l-4.7,3,3-5.39A13.74,13.74,0,0,0,534,315.11c-4.88,0-9.23,2.9-12,7.43a9,9,0,0,1-8,4.29h-.26c-5.39,0-9.76,6.11-9.76,13.65s4.37,13.65,9.76,13.65a7.35,7.35,0,0,0,3.4-.85,14,14,0,0,1,11.81-.23,12.41,12.41,0,0,0,5,1.08,12.28,12.28,0,0,0,5-1.06,14.08,14.08,0,0,1,11.71.23,7.33,7.33,0,0,0,3.37.83c5.39,0,9.76-6.11,9.76-13.65A17.31,17.31,0,0,0,561.8,332.13Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M547.21,352.11a14.4,14.4,0,0,0-8.36.91,12.53,12.53,0,0,1-5,1.06A12.29,12.29,0,0,1,528.8,353a14.08,14.08,0,0,0-11.81.24,7.32,7.32,0,0,1-3.4.85c-4.79,0-8.77-4.83-9.6-11.19a9.21,9.21,0,0,0,2.39-2.58c2.81-4.53,7.16-7.43,12-7.43s9.18,2.87,12,7.34a9.26,9.26,0,0,0,8,4.38h.12C542.3,344.59,545.61,347.65,547.21,352.11Z",
  transform: "translate(-68.5 -92.46)",
  opacity: 0.03
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M599,178.34l12.43,7.89-7.55-13.73a12.32,12.32,0,0,1,7.52-2.68h.2a15.67,15.67,0,0,0,2.58-.19l4.22,2.67L616.56,169a15,15,0,0,0,7.37-5.59l7.55,4.78-4.77-8.66c4.41-5.3,10.36-8.54,16.9-8.54,7.85,0,14.83,4.66,19.34,11.93a14.45,14.45,0,0,0,12.79,6.89h.42c8.66,0,15.68,9.81,15.68,21.93s-7,21.92-15.68,21.92a11.8,11.8,0,0,1-5.46-1.36,22.59,22.59,0,0,0-19-.37,20,20,0,0,1-8.11,1.73,19.73,19.73,0,0,1-8-1.7,22.65,22.65,0,0,0-18.81.37,11.85,11.85,0,0,1-5.41,1.33c-8.66,0-15.68-9.81-15.68-21.92A27.89,27.89,0,0,1,599,178.34Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M622.4,210.43a23.14,23.14,0,0,1,13.44,1.46,19.77,19.77,0,0,0,16.13,0,22.67,22.67,0,0,1,19,.37,11.69,11.69,0,0,0,5.46,1.37c7.69,0,14.09-7.75,15.43-18a14.69,14.69,0,0,1-3.85-4.15c-4.51-7.26-11.5-11.93-19.34-11.93s-14.75,4.61-19.26,11.8a14.83,14.83,0,0,1-12.78,7h-.2C630.29,198.36,625,203.27,622.4,210.43Z",
  transform: "translate(-68.5 -92.46)",
  opacity: 0.03
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M392.74,402.41c-.52-.79-3.07,0-5.69,1.71-.46.31-.9.63-1.3.95a18.84,18.84,0,0,0-5.82-1.9l.11-.08a44.21,44.21,0,0,0,7.31-6h-5.63l8.17-3.14c1-1.59,1.32-2.92.77-3.75-1.48-2.22-8.62-.08-16,4.8a39.56,39.56,0,0,0-8.87,7.73c-6,.7-10.21,2.46-10.21,4.51,0,1.42,2,2.7,5.25,3.59l-.19.12c-7.34,4.87-12.1,10.63-10.62,12.85,1.3,2,7,.52,13.38-3.19l-4.23-2,6.67.46.14-.09c.71-.47,1.39-.95,2.05-1.43l-5-2.32,7.33.5a35.12,35.12,0,0,0,3.88-3.75c6.83-.36,12.17-2,13.1-4.12A18.17,18.17,0,0,0,389,407a15.6,15.6,0,0,0,2.6-2.12h-2l2.91-1.12C392.83,403.18,392.94,402.71,392.74,402.41Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#f2f2f2"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M198.48,706.17a49,49,0,0,1-1,10.19c-.14.63-.28,1.25-.42,1.85-3.73,14.95-14.25,25.89-26.8,26.59-.42,0-.84,0-1.28,0-13.27,0-24.49-11.45-28.2-27.22-.1-.42-.19-.84-.29-1.26a49,49,0,0,1-1.05-10.19c0-21.36,13.23-38.67,29.54-38.67S198.48,684.81,198.48,706.17Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#3f3d56"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M198.48,706.17a49,49,0,0,1-1,10.19c-.14.63-.28,1.25-.42,1.85-.45,0-.88,0-1.33-.05a60.08,60.08,0,0,1-9.66-1.33,59.23,59.23,0,0,1-8.62,2,60,60,0,0,1-6.75.63c-.76,0-1.52,0-2.28,0a60.07,60.07,0,0,1-8.09-.54,58.93,58.93,0,0,1-12.69-3.15,60.75,60.75,0,0,1-6.86,1.84c-.1-.42-.19-.84-.29-1.26a49,49,0,0,1-1.05-10.19c0-21.36,13.23-38.67,29.54-38.67S198.48,684.81,198.48,706.17Z",
  transform: "translate(-68.5 -92.46)",
  opacity: 0.1
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M261.5,634.13a59.79,59.79,0,0,0-6.43-27l-34.75,10.81L250.82,600a60,60,0,0,0-45.11-25.72A60.28,60.28,0,0,0,201,568l-49.94,15.53L192,559.51a60,60,0,0,0-94.49,32l42.75,49.2L93.84,607.19a60.05,60.05,0,0,0,53.74,106A60.26,60.26,0,0,0,186,714.21a60.1,60.1,0,0,0,73-58.63c0-1.34-.05-2.66-.14-4A59.93,59.93,0,0,0,261.5,634.13Z",
  transform: "translate(-68.5 -92.46)",
  fill: "#57b894"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M260.46,645.27a160.2,160.2,0,0,0-55.59-.71c-20.86,3.46-42.18,11.05-62.58,5.5-12-3.26-22.34-10.79-34-15A64.48,64.48,0,0,0,73.15,633a60.07,60.07,0,0,0,74.43,80.17A60.26,60.26,0,0,0,186,714.21a60.1,60.1,0,0,0,73-58.63c0-1.34-.05-2.66-.14-4A57.32,57.32,0,0,0,260.46,645.27Z",
  transform: "translate(-68.5 -92.46)",
  opacity: 0.1
});

var SvgUndrawStabilityBallB4Ia = function SvgUndrawStabilityBallB4Ia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "b8ce3bdc-917d-4964-b09e-b00e16d8f23c",
    "data-name": "Layer 1",
    width: 1063.01,
    height: 715.08,
    viewBox: "0 0 1063.01 715.08",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndrawStabilityBallB4Ia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undraw_Stability_ball_b4ia.f19ef8c2.svg";
export { ForwardRef as ReactComponent };